//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

import arrowOrange from '@/assets/imgs/arrow-orange.svg';

export default {
  name: 'BlogForm',

  data() {
    return {
      arrowOrange,

      all: false,
      planning: false,
      design: false,
      development: false,
      content: false,
      marketing: false,
      seo: false,
      other: false,
      email: '',

      error: false,
      submitting: false
    };
  },

  computed: {
    form() {
      return {
        input_1_1: this.all ? 'All' : false,
        input_1_2: this.planning ? 'Planning' : false,
        input_1_3: this.design ? 'UX/UI' : false,
        input_1_4: this.development ? 'Development' : false,
        input_1_5: this.content ? 'Content' : false,
        input_1_6: this.marketing ? 'Marketing' : false,
        input_1_7: this.seo ? 'SEO' : false,
        input_1_8: this.other ? 'Other' : false,
        input_6: this.email
      };
    },

    submitBg() {
      return `background-image: url("${arrowOrange}");`;
    }
  },

  methods: {
    async formSubmit(e) {
      e.preventDefault();
      // console.log(this.form);

      this.$wpJson.gf.submit(2, this.form)
        .then((response) => {
          // console.log(response);
          if (response.is_valid === true) {
            // you had a successful call
            this.thanks = true;
            this.submitting = false;

            this.all = false;
            this.planning = false;
            this.design = false;
            this.development = false;
            this.content = false;
            this.marketing = false;
            this.seo = false;
            this.other = false;
            this.email = '';
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.is_valid === false) {
              this.error = true;
              this.submitting = false;
            }
          }
        });
    }
  }
};
